import { StyledIconUserPlus } from './IconUserPlus.styled';

const IconUserPlus = () => {
  return <StyledIconUserPlus />;
};

export default IconUserPlus;
